import {
  AutoMarkType,
  QuestionDifficulty,
  QuestionType
} from "services/shortAnswerService/question-types/common";

import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics/gtm";
import { examQuestionsAnalyticsNamespace } from "seneca-common/features/exam-questions/consts";

export enum ExamQuestionsSource {
  courseSidebar = "courseSidebar",
  sectionHomepage = "sectionHomepage",
  sectionHomepageRecommended = "sectionHomepageRecommended",
  endSessionAdScreen = "endSessionAdScreen",
  endSessionTryMore = "endSessionTryMore",
  endSessionAssignmentProgressScreen = "assignmentProgressScreen",
  retry = "retry",
  closedModalAtEndOfSession = "closedModalAtEndOfSession",
  assignmentTile = "assignmentTile",
  assignmentSidebar = "assignmentSidebar",
  studyCourseModal = "studyCourseModal",
  partOfAssignment = "partOfAssignment",
  selfStudy = "selfStudy",
  teacherMarkingModal = "teacherMarkingModal",
  teacherSpeedyMarking = "teacherSpeedyMarking",
  selectMode = "selectMode",
  miniMock = "miniMock",
  examQuestionEndSession = "examQuestionEndSession"
}

export function logClickStartExamQuestions() {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/CLICK_START`,
    payload: {}
  });
}

export type ExamQuestionAnalyticsContext = {
  questionId: string;
  assignmentId: string;
  difficulty?: QuestionDifficulty;
  submissionId: string;
  selfMarkedQuestion: boolean;
  maxMarkQuestion: number;
  source: ExamQuestionsSource;
  answerText?: string;
  autoMarkType?: AutoMarkType;
  questionType?: QuestionType;
};

export function logStartExamQuestionWithContext(
  examQuestionAnalyticsPayload: ExamQuestionAnalyticsContext
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/START`,
    payload: examQuestionAnalyticsPayload
  });
}

export function logSubmitExamQuestionWithContext(
  examQuestionAnalyticsPayload: ExamQuestionAnalyticsContext
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/SUBMIT`,
    payload: examQuestionAnalyticsPayload
  });
}

export function logStartExamQuestionDictation() {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/START_DICTATION`,
    payload: {}
  });
}

export function logSubmitFlaggedAnswerWithContext(
  payload: ExamQuestionAnalyticsContext & {
    autoMark?: number;
    selfMark?: number;
  }
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/WRONG_MARK`,
    payload
  });
}

export function logMarkingErroredWithContext(
  payload: ExamQuestionAnalyticsContext
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/MARKING_ERRORED`,
    payload
  });
}

export function logExamQuestionAutoMarkedWithContext(
  payload: ExamQuestionAnalyticsContext & {
    answerTimeCreated: string;
    autoMark?: number;
    autoMarkingTime: number;
  }
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/AUTO_MARK`,
    payload
  });
}

export enum GatingType {
  maxQuestionsSelected = "maxQuestionsSelected",
  maxQuestionsStudied = "maxQuestionsStudied",
  hardQuestions = "hardQuestions",
  enableAutoMarking = "enableAutoMarking",
  wrongAnswers = "wrongAnswers",
  aiMarking = "aiMarking",
  miniMockPapers = "miniMockPapers"
}

export function logExamQuestionGating(gatingType: GatingType) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/GATING`,
    payload: {
      gatingType
    }
  });
}

export function logClickRandomTopicsButton() {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/RANDOM_TOPICS`,
    payload: {}
  });
}

export function logReceiveExamQuestionsGift() {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${examQuestionsAnalyticsNamespace}/RECEIVE_GIFT`,
    payload: {}
  });
}
